import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUS = ["pending", "confirmed", "preparing", "out_for_delivery", "delivered", "cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/orders/${id}/status`, { status });
    toast.success("Status updated");
    load();
  };

  return (
    <div>
      <div className="overline">Fulfilment</div>
      <h1 className="font-display text-3xl mt-1">Orders</h1>
      <div className="mt-6 admin-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F2EC] text-left">
            <tr>
              <th className="p-4">Order</th>
              <th className="p-4">Customer</th>
              <th className="p-4">Items</th>
              <th className="p-4">Delivery</th>
              <th className="p-4">Total</th>
              <th className="p-4">Payment</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>
          <tbody data-testid="admin-orders-table">
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-[#E5DFD3]">
                <td className="p-4 font-mono text-xs">{o.id.slice(0, 8)}</td>
                <td className="p-4">
                  <div>{o.customer_name}</div>
                  <div className="text-xs text-[#6C665F]">{o.customer_email}</div>
                </td>
                <td className="p-4 text-xs">
                  {o.items.map((i, idx) => <div key={idx}>{i.name} × {i.quantity}</div>)}
                </td>
                <td className="p-4 text-xs">
                  <div>{o.delivery_date}</div>
                  <div className="text-[#6C665F]">{o.delivery_slot}</div>
                  <div className="text-[#6C665F]">{o.address.pincode}</div>
                </td>
                <td className="p-4 font-semibold">₹{o.total}</td>
                <td className="p-4 text-xs">
                  <div className="capitalize">{o.payment_method === "cod" ? "COD" : "Online"}</div>
                  <div className="text-[#6C665F] capitalize">{o.payment_status}</div>
                </td>
                <td className="p-4">
                  <select value={o.status} onChange={(e) => setStatus(o.id, e.target.value)} className="input-eko !py-1 !px-2 text-xs" data-testid={`status-${o.id}`}>
                    {STATUS.map((s) => <option key={s} value={s}>{s.replace(/_/g, " ")}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {orders.length === 0 && (
              <tr><td colSpan={7} className="p-8 text-center text-[#6C665F]">No orders yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
